module.exports = __webpack_public_path__ + "static/unicef-logo-in-nav-d923f35a56e5dac2b008e4d2d1e89e1e.png";